export enum columns {
  ONE_THIRD = 'md:col-span-2',
  TWO_THIRD = 'md:col-span-4',
  ONE_HALF = 'md:col-span-3',
  FULL = 'md:col-span-6',
}
